module.exports = require("date-fns/format");


//////////////////
// WEBPACK FOOTER
// external "date-fns/format"
// module id = 6
// module chunks = 0